<template>
  <div>
    <template v-if="user && user.account_type">
      <counselor-messages-impl
        v-if="!flag.loader && isCounselor && targetUserId"
        mode="sender"
        :target_user_id="targetUserId"
        :enable_message_send="enableMessageSend"
      />

      <not-found
        v-if="!isCounselor"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CounselorMessagesImpl from '@/views/pages/Common/CounselorMessagesImpl.vue';
import NotFound from '@/views/404.vue';

import cf from '@/mixins/commonFunctions';

export default {
  name: 'CounselorCounselorMessages',
  components: {
    CounselorMessagesImpl,
    NotFound,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
      enableMessageSend: false, // 対象者へのメッセージ送信可否
    };
  },
  computed: {
    ...mapState(['user']),
    isCounselor() {
      return this.user && [21, 22].includes(this.user.account_type);
    },
  },
  async created() {
    // stateのユーザ情報が未取得の場合、取得完了まで待機
    if (this.user && this.user.id) {
      this.initialize();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/setUserData') {
          this.initialize();
        }
      });
    }
  },
  methods: {
    async initialize() {
      // pathVariableパラメータの取得
      const slug = cf.convert2Num(this.$route.params.slug);
      this.targetUserId = slug;
      if (!slug) {
        return;
      }
      // メインカウンセラーの情報を取得
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/userWatch/get/mainCounselor',
          params: { user_id: this.targetUserId },
        });
        if (response.data.data) {
          const mainCounselor = response.data.data.main_counselor;
          this.enableMessageSend = mainCounselor ? mainCounselor.id === this.user.id : false; // ログインユーザ自身がメインカウンセラーの場合のみ送信可能
        }
      } catch (error) {
        console.error('メインカウンセラーの情報の取得に失敗:', error);
      }
      // 初期処理完了
      this.flag.loader = false;
    },
  },
};
</script>

<style lang="scss" module>
</style>
